<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("foodcategories", 2) }}</div>
      </div>
      <div>
        <b-button
          v-if="isEditable && $can('update', 'Food Categories')"
          variant="default"
          class="btn-blue"
          @click="() => updateOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else-if="$can('update', 'Food Categories')"
          variant="default"
          class="btn-blue"
          @click="() => editOrder()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button
          v-if="$can('create', 'Food Categories')"
          variant="default"
          to="add-food-categories"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="onVendorSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown
          :onSelect="(filterIsActive) => getVendorsList(filterIsActive)"
        /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(fc, vendorkey) in ms_food_categories"
        :key="vendorkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ fc.fc_category }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Food Categories')"
                  @click="goToRoute('/fnb/edit-food-categories', fc)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-food-categories', fc)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="fc.fc_is_active == 'Y' ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-5">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 300px">
            <img
              v-if="this.columnName != 'fc_category'"
              @click="onSortValue('fc_category', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('fc_category', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('fc_category', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("foodcategory", 2) }}
          </th>
          <th class="text-left pl-2">{{ $t("foodorder") }}</th>
        </tr>
      </thead>
      <template v-if="ms_food_categories && ms_food_categories.length > 0">
        <draggable
          :list="ms_food_categories"
          tag="tbody"
          v-bind="dragOptions"
          :move="draggableElements"
          @end="
            endSort($event);
            drag = false;
          "
          @start="drag = true"
        >
          <tr v-for="(fc, vendorkey) in ms_food_categories" :key="vendorkey">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot :status="fc.fc_is_active == 'Y' ? 'active' : 'inactive'" />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Food Categories')"
                    @click="goToRoute('/fnb/edit-food-categories', fc)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/fnb/view-food-categories', fc)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="fc.fc_is_active == 'Y' ? 'active' : 'inactive'"
                />
                <div
                  v-if="$can('update', 'Food Categories')"
                  class="ml-4 clickable-icon"
                  @click="goToRoute('/fnb/edit-food-categories', fc)"
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
                <div
                  class="ml-2 clickable-icon"
                  @click="goToRoute('/fnb/view-food-categories', fc)"
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              </div>
            </td>

            <td>{{ fc.fc_category }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-start pl-5">
                {{ fc.fc_order }}
              </div>
            </td>
          </tr>
        </draggable>
      </template>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import draggable from "vuedraggable";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    draggable,
  },
  data() {
    return {
      filter_is_active: "Y",
      filterButtonTitle: "Active",
      drag: false,
      perPage: 10,
      currentPage: 1,
      isEditable: false,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      ms_food_categories: [],
      viewingnumbers: [],
      URL_BASE: BASEURL,
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "asc",
      columnName: "fc_order",

      debounce: null,
      searchValue: "",
      searchKey: "fc_category",
      statuses: [
        { status: "Active", flag: "Y" },
        { status: "Inactive", flag: "N" },
        { status: "All", flag: "" },
      ],
      selectedStatus: "Active",
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    this.getVendorsList();
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  methods: {
    draggableElements: function () {
      return this.isEditable;
    },
    endSort(event) {
      this.ms_food_categories.map((x, index) => {
        if (this.currentPage != 1) {
          x.fc_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.fc_order = index + 1;
        }
      });
      console.log("this.sorted Labels", this.Labels);
      console.log("this.event", event);
    },
    editOrder: function () {
      this.isEditable = true;
      if (this.isEditable) {
        this.filterButtonTitle = "Active";
        this.selectedStatus = "Active";
        this.filter_is_active = "Y";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    updateOrder: function () {
      this.isEditable = false;
      let payload = {
        ms_food_categories: this.ms_food_categories,
      };
      PosFnbService.UpdateCategoryOrder(payload)
        .then((data) => {
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status.status;
      this.selectedStatus = status.status;
      this.filter_is_active = status.flag;
      // this.isEditable = false;
      this.getVendorsList();
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getVendorsList();
      } else {
        this.currentPage = event;
        this.getVendorsList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getVendorsList();
    },
    getVendorsList: function () {
      this.ms_food_categories = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        filter_is_active: this.filter_is_active,
      };
      PosFnbService.GetFoodCategories(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show("No Records Found");
          }
        })
        .catch(this._CatchError);
    },
    goToRoute: function (path, { fc_id }) {
      console.log("fc_id :", fc_id);
      this.$router.push({
        path: path,
        query: {
          fc_id: fc_id,
        },
      });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    onVendorSearch: function () {
      this.getVendorsList();
    },
  },
};
</script>
<style>
.ghost {
  background: #b6d2fd63;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/foodCategories.vue